import { FONT, TourPalette } from './tourTheme';

// driver.js ships a plain default popover. This restyles it into the welcome
// tour's own language — Instrument Sans titles, Inter body, mono progress,
// accent buttons — so an in-app walkthrough doesn't look bolted on.
export const POPOVER_CLASS = 'tc-tour-popover';

export const driverPopoverStyles = (p: TourPalette) => ({
  [`.driver-popover.${POPOVER_CLASS}`]: {
    background: p.tipBg,
    color: p.fg,
    borderRadius: '14px',
    border: `1px solid ${p.accent}`,
    boxShadow: '0 28px 70px rgba(0,0,0,.45)',
    maxWidth: 360,
    padding: '20px 22px 16px',
    fontFamily: FONT.body
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-title`]: {
    font: `600 16px/1.3 ${FONT.display}`,
    letterSpacing: '-.01em',
    color: p.fg,
    marginBottom: '10px'
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description`]: {
    font: `400 12.8px/1.6 ${FONT.body}`,
    color: p.fg,
    opacity: 0.78
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description p`]: { margin: 0 },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description ul`]: {
    margin: '10px 0 0',
    padding: 0,
    listStyle: 'none'
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description li`]: {
    position: 'relative',
    padding: '7px 0 7px 14px',
    borderTop: `1px solid ${p.line}`
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description li:first-of-type`]: { borderTop: 'none' },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description li::before`]: {
    content: '""',
    position: 'absolute',
    left: 0,
    top: '15px',
    width: 5,
    height: 5,
    borderRadius: '50%',
    background: p.accent
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description strong`]: {
    color: p.fg,
    opacity: 1,
    fontWeight: 600
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description em`]: { color: p.aText, fontStyle: 'normal', fontWeight: 600 },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-description a`]: {
    display: 'inline-block',
    marginTop: '4px',
    font: `500 12px/1 ${FONT.body}`,
    color: p.aText,
    textDecoration: 'none',
    borderBottom: `1px solid ${p.accent}55`
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-progress-text`]: {
    font: `500 10.5px/1 ${FONT.mono}`,
    letterSpacing: '.12em',
    textTransform: 'uppercase',
    color: p.fg,
    opacity: p.muted
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-footer`]: {
    marginTop: '16px',
    paddingTop: '14px',
    borderTop: `1px solid ${p.line}`,
    gap: '8px'
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-footer button`]: {
    font: `600 12px/1 ${FONT.body}`,
    padding: '10px 15px',
    borderRadius: '9px',
    textShadow: 'none',
    border: `1px solid ${p.line2}`,
    background: 'transparent',
    color: p.fg
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-footer .driver-popover-next-btn`]: {
    background: p.accent,
    borderColor: p.accent,
    color: p.accentInk
  },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-footer button:hover`]: { filter: 'brightness(1.08)' },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-close-btn`]: { color: p.fg, opacity: p.muted2 },
  // The popover carries a 1px accent border, so a triangle in the background
  // colour reads as detached from the edge it grows out of. Colouring the arrow
  // with the border colour keeps the pointer continuous with the outline, and
  // the 1px pull-in closes the seam the border would otherwise leave.
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-arrow-side-left`]: { borderLeftColor: p.accent, marginRight: '-1px' },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-arrow-side-right`]: { borderRightColor: p.accent, marginLeft: '-1px' },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-arrow-side-top`]: { borderTopColor: p.accent, marginBottom: '-1px' },
  [`.driver-popover.${POPOVER_CLASS} .driver-popover-arrow-side-bottom`]: { borderBottomColor: p.accent, marginTop: '-1px' }
});
